import { getCurrentUser } from "./auth";

export const isAdmin = () => {
  return getCurrentUser();
};

/**
 * Format timestamp to 12-hour format (e.g., "7:30 AM")
 */
export const formatTime12Hour = (timestamp) => {
  return new Date(timestamp).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

/**
 * Determine if a time slot is morning (before 12 PM) or evening
 */
export const getSession = (timestamp) => {
  const hour = new Date(timestamp).getHours();
  return hour < 12 ? "morning" : "evening";
};

/**
 * Group schedule slots by session (morning/evening)
 */
export const groupBySession = (schedule) => {
  const groups = { morning: [], evening: [] };
  schedule?.forEach((slot) => {
    const session = getSession(slot.startTime);
    groups[session].push(slot);
  });
  return groups;
};

/**
 * Check if clinic is currently open based on any doctor's schedule
 */
export const isClinicOpen = (doctors) => {
  if (!doctors?.length) return false;
  const now = Date.now();
  return doctors.some((doctor) =>
    doctor.schedule?.some(
      (slot) => now >= slot.startTime && now <= slot.endTime
    )
  );
};

/**
 * Get formatted date string (e.g., "Friday, Dec 19")
 */
export const getFormattedDate = () => {
  return new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
  });
};

/**
 * Get or create a deviceId persisted in localStorage
 * @returns {string|null}
 */
export const persistDeviceId = () => {
  try {
    const cachedId = localStorage.getItem("deviceId");
    if (cachedId) return cachedId;
    const generatedId =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem("deviceId", generatedId);
    return generatedId;
  } catch (error) {
    console.error("Unable to persist deviceId", error);
    return null;
  }
};
